import { Box } from "@mui/material"
import { FC } from "react"

interface INumberFormat {
    number: number
    decimals?: number // явное указание точности (опционально)
    symbol?: string   // символ валюты (по умолчанию $)
}

export const NumberFormat: FC<INumberFormat> = ({
    number,
    decimals,
    symbol = "$"
}) => {
    const formatNumber = (num: number, maxDecimals = 8): string => {
        // Преобразуем число в строку
        let str = num.toString()

        // Обработка экспоненциальной записи (для очень малых чисел типа 8.564e-5)
        if (str.includes('e')) {
            // Используем toFixed для получения полного представления
            str = num.toFixed(maxDecimals)
        }

        // Разделяем на целую и дробную часть
        const [integerPart, decimalPart = ''] = str.split('.')

        // Обрезаем дробную часть до maxDecimals знаков (БЕЗ округления)
        const trimmedDecimal = decimalPart.slice(0, maxDecimals)

        // Убираем незначащие нули справа
        const finalDecimal = trimmedDecimal.replace(/0+$/, '')

        // Форматируем целую часть с разделителями тысяч
        const formattedInteger = new Intl.NumberFormat("en-US").format(
            parseInt(integerPart)
        )

        // Собираем итоговый результат
        return finalDecimal
            ? `${formattedInteger}.${finalDecimal}`
            : formattedInteger
    }

    // Определяем максимальное количество знаков
    const maxDecimals = decimals !== undefined ? decimals : 8

    // Форматируем число
    const formattedNumber = formatNumber(number, maxDecimals)

    return (
        <>
            {formattedNumber}
            <Box sx={{ fontWeight: 700, pl: .6 }} component="span">
                {symbol}
            </Box>{" "}
        </>
    )
}